export default [
  {
    // place ที่ยังไม่ถูกผูกโซน — ไล่เก็บงานค้าง
    path: '/place/without-zone',
    name: 'place-without-zone',
    component: () => import('@/views/places/PlacesWithoutZone.vue'),
    meta: {
      resource: 'Place',
      action: 'read',
    },
  },
  {
    // ตรวจพิกัดของ place ทั้งหมด (นอกไทย / ซ้ำ / หลุดโซน)
    path: '/place/coordinate-audit',
    name: 'place-coordinate-audit',
    component: () => import('@/views/places/PlaceCoordinateAudit.vue'),
    meta: {
      resource: 'Place',
      action: 'read',
    },
  },
  {
    // ตรวจ "พิกัดที่แนะนำ" ก่อนนำไปใช้จริง (ยังไม่แก้ lat/lng)
    path: '/place/coord-review',
    name: 'place-coord-review',
    component: () => import('@/views/places/PlaceCoordReview.vue'),
    meta: {
      resource: 'Place',
      action: 'read',
    },
  },
  {
    path: '/place/lists',
    name: 'place-lists',
    component: () => import('@/views/property-pins/pin-lists/PropertyPinList.vue'),
    meta: {
      resource: 'Place',
      action: 'read',
    },
  },
  {
    path: '/property-pin/add',
    name: 'pin-create',
    component: () => import('@/views/property-pins/pin-form/PinForm.vue'),
    meta: {
      resource: 'Place',
      action: 'create',
    },
  },
  {
    path: '/property-pin/edit/:id',
    name: 'pin-edit',
    component: () => import('@/views/property-pins/pin-form/PinForm.vue'),
    meta: {
      resource: 'Place',
      action: 'update',
    },
  },
  {
    path: '/property-pin/floorplan/:id',
    name: 'pin-floorplan',
    component: () => import('@/views/property-pins/pin-floorplan/PinFloorplan.vue'),
    meta: {
      resource: 'Place',
      action: 'update',
    },
  },
  {
    path: '/property-pin/upload/:id',
    name: 'pin-upload',
    component: () => import('@/views/property-pins/pin-upload/pinUpload.vue'),
    meta: {
      resource: 'Property',
      action: 'update',
    },
  },
]
